
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useRoute } from "vue-router";
export default {
  name: "SiteFooter",
  components: { FontAwesomeIcon },
  setup() {
    const route = useRoute();

    const links = [
      {
        url: "https://www.linkedin.com/in/brenda-cayzac-138297103/",
        icon: "fab fa-linkedin",
      },
      {
        url: "https://www.behance.net/brendacayzeb7a?isa0=1",
        icon: "fab fa-behance-square",
      },
      {
        url: "https://www.behance.net/brendacayzeb7a",
        icon: "fa-brands fa-github-square",
      },
    ];

    return {
      links,
      route,
    };
  },
};
